import { z } from 'zod'

export const AutoScheduleSchema = () => {
  return z.object({
    locationId: z.string(),
    startAt: z.string(),
    endAt: z.string(),
    restDaysPerWeek: z.boolean(),
    agreementHours: z.boolean(),
    restHoursBetweenShifts: z.boolean(),
    maxWorkHoursPerDay: z.boolean(),
    employeeSelection: z.discriminatedUnion('type', [
      z.object({
        type: z.literal('manual'),
        ids: z.array(z.string()),
      }),
      z.object({
        type: z.literal('all'),
        filters: z.record(z.unknown()).optional(),
        excludedIds: z.array(z.string()),
        includeInactive: z.boolean().optional(),
      }),
    ]),
  })
}

export type AutoScheduleSchemaType = z.infer<ReturnType<typeof AutoScheduleSchema>>
